export const ACCORDION_TOGGLE = 'accordion:toggle'
